import { render, staticRenderFns } from "./TaskFolderComponent.vue?vue&type=template&id=0cc5a0db&scoped=true&"
import script from "./TaskFolderComponent.vue?vue&type=script&lang=js&"
export * from "./TaskFolderComponent.vue?vue&type=script&lang=js&"
import style0 from "./TaskFolderComponent.vue?vue&type=style&index=0&id=0cc5a0db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc5a0db",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VIcon,VListGroup,VListItemTitle,VTreeview})
